module.exports = __webpack_public_path__ + "img/ir.b4e0e128.svg";